import React from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from '@michelin/central-provider';
import { useGetPrices } from 'hooks/useGetPrices';
import { getMspn } from 'utils/getMspn';
import { CommonPricesParamsType } from 'utils/getPricesCallCommonParams';
import { BREAKPOINT } from 'utils/responsivenessUtils';
import { getTotalPartTAX } from 'utils/taxes';

interface ProductSubTotalProps {
  parts: any[];
  qty: number;
  commonPricesParams: CommonPricesParamsType;
}

export default function ProductSubTotal(props: ProductSubTotalProps) {
  const { t } = useTranslation();

  const { parts, commonPricesParams, qty } = props;
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down(BREAKPOINT));

  const pricesResponse = useGetPrices({
    ...commonPricesParams,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    parts: parts.map((p) => ({ mspn: getMspn(p) as string, qty, is_pql: false })),
  });

  // if (order) relatedParts = order.parts.filter((p) => p.related_to === relatedTo);

  if (!pricesResponse.data) return null;
  let totalTaxes = 0;
  pricesResponse.data.parts.forEach((part) => {
    totalTaxes += getTotalPartTAX(part, qty);
  });

  let totalPrice = 0;
  pricesResponse.data.parts.forEach((part) => {
    totalPrice += Number(part.invoice_price) * qty;
  });

  return (
    <Grid container spacing={2}>
      {!mobileView && <Grid item xs={8} />}
      <Grid item xs={12} style={{ textAlign: 'right' }}>
        <Typography style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
          {t('Total product estimated taxes: ${{totalTax}}', { totalTax: totalTaxes.toFixed(2) })}
        </Typography>
        <Typography style={{ fontSize: 10 }}>
          {t('Final tax amounts will be calculated at the time of order completion')}
        </Typography>
        <Typography style={{ fontSize: 12, fontWeight: 'bold', whiteSpace: 'nowrap' }}>
          {t('Total product: ${{totalPrice}}', { totalPrice: (totalPrice + totalTaxes).toFixed(2) })}
        </Typography>
      </Grid>
    </Grid>
  );
}
